import snakeCase from 'lodash/snakeCase'
import { getGuestPassAdvocatePropertiesAsync } from '../../guest-pass'
import { Advocate, Origin, Source } from '../types'
import { getFreeTrialDurationAsync } from './getFreeTrialDurationAsync'
import { getFreeTrialSourceAsync } from './getFreeTrialSourceAsync'
import { isFreeTrialCartEnabledAsync } from './isFreeTrialCartEnabledAsync'

export const getFreeTrialOriginCartPropsAsync = async (
  isGift = false,
  refresh = false,
) => {
  const freeTrialCartEnabled = await isFreeTrialCartEnabledAsync(
    isGift,
    refresh,
  )

  // User could be eligible for free trial but they are purchasing
  // a gift or a single class
  if (!freeTrialCartEnabled) {
    return {
      is_free_trial: false,
      free_trial_origin: { name: 'no_free_trial' },
    }
  }

  const source: Origin = (await getFreeTrialSourceAsync(refresh)) as Source
  const advocate: Advocate | null | undefined =
    await getGuestPassAdvocatePropertiesAsync(refresh)

  if (advocate) {
    source.advocateId = advocate.id
    source.advocateEmail = advocate.email
    source.trialLength = await getFreeTrialDurationAsync(refresh)
  }

  const snakeCaseSource: Record<string, unknown> = {}

  ;(Object.keys(source) as (keyof Source)[]).forEach((key) => {
    snakeCaseSource[snakeCase(key)] = source[key]
  })

  return {
    is_free_trial: freeTrialCartEnabled,
    free_trial_origin: snakeCaseSource,
  }
}
